import { ELanguage } from '@core/type/language';

export const addParameters = (url: string, params: Record<string, string | string[]>): string => {
  const searchParams = new URLSearchParams();
  for (const key in params) {
    const value = params[key];
    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(key, v));
    } else if (value !== undefined && value !== null) {
      searchParams.set(key, value);
    }
  }
  const separator = url.includes('?') ? '&' : '?';
  const queryString = searchParams.toString();
  return url + (queryString ? separator + queryString : '');
};

export const getFullPathURL = (
  locationOrigin: string,
  language: ELanguage,
  href: string,
): string => {
  return `${locationOrigin}/${language === ELanguage.DEFAULT ? ELanguage.EN : language}${href}`;
};
